module.exports = __webpack_public_path__ + "img/Polygon 11.074a9ae2.svg";